import { getRandomBytes } from './lib/get-random-bytes'

export * from './components/FiddleDevTools'
export * from './components/FiddleEditor'
export { types as fiddleEditorTypings } from './components/FiddleEditor-Types'
export * from './components/FiddleResult'
export * from './components/FiddleUrlBar'
export * from './components/FiddleSidebarModules'
export * from './components/MonacoEditor'
export * from './components/RawRequestPane'
export * from './components/common'

export function generateSessionId() {
  return getRandomBytes()
}



// WEBPACK FOOTER //
// ./src/index.ts